
export default [
  {
    path: "/orders",
    name: "Orders",
    component: () => import("@/pages/sale/SalesPage.vue"),
  },
  {
    path: "/orders/new",
    name: "NewOrder",
    component: () => import("@/pages/sale/NewSalePage.vue"),
  },
  {
    path: "/orders/details/:orderCode",
    name: "OrderDetails",
    component: () => import("@/pages/sale/SaleDetailsPage.vue"),
  },
  {
    path: "/orders/invoices",
    name: "OrderInvoices",
    component: () => import("@/pages/accounting/InvoicesPage.vue"),
    meta: { requiresAuth: true },
  },
];